<svelte:options accessors={true} />

<script>
    import { Fields, Field, Form, Input, Label, Text, Icon, Button } from "svantic";
    import { BetSettingsLocal } from "../../stores"
    import { onMount } from 'svelte'
    import { currencyValue } from "../balance";

    const formatCurrency = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 9,
        minimumFractionDigits: 0,
        minimumIntegerDigits: 1,
    });

    onMount(() =>{
        
        //set settings to store values
        i_amount = $BetSettingsLocal.amount
        i_chance =  $BetSettingsLocal.chance
        i_rows = $BetSettingsLocal.rows
        i_lines =  $BetSettingsLocal.lines
        i_multiplier = $BetSettingsLocal.multiplierTarget
        i_risk =  $BetSettingsLocal.risk
        arr_numbers = $BetSettingsLocal.numbers
        i_segments =  $BetSettingsLocal.segments

        return ()=>{


         }
     })
   // export let amount = 0;
    let multiplier = 2;
    let chance = 0.495;

    let form = undefined;
    let i_amount = 0.00000000
    let amount = i_amount.toFixed(8)
    let i_chance = 49.5
    let i_multiplier = 2
    let i_condition = 'below' //  'below' || 'above'
    let i_lines = 1
    let i_minesCount = 12 
    let fields = []
    let i_rows = 16
    let i_risk = "high"
    let i_difficulty = "master"
    let i_numbers = ""
    let i_segments = 50
    let arr_numbers = []

    export const getBetConfig = () => {
        return { amount: amount, chance: i_chance, multiplierTarget: i_multiplier };
    };

    export let BetConfig

    export const setBetAmount = (val) => {
        if(Number.isInteger(val))
            amount = val
            i_amount = amount.toFixed(8)

      
    }

  //  $: arr_numbers = i_numbers.replaceAll(" ","").split(",").map( v => parseInt(v)-1)

    $: {
        // chance = (range * 0.99) / multiplierTarget / 100
        i_chance = Math.floor(9900 / i_multiplier) / 100
    }
    $: {
         BetConfig = { amount: parseFloat(i_amount),  chance: i_chance, condition: i_condition, target: (i_condition == 'below') ? Math.floor(i_chance*100)/100 : Math.floor(10000-(i_chance*100))/100 ,  multiplierTarget: parseFloat(i_multiplier), lines: parseInt(i_lines), rows: parseInt(i_rows), risk: i_risk, difficulty: i_difficulty, minesCount: parseInt(i_minesCount), segments: parseInt(i_segments) };
         BetSettingsLocal.update(BetConfig)
    }
   
    console.log("get BetSettings ", () => $BetSettingsLocal )
    export let game 
</script>

<Form
    bind:this={form}
    on={{
        submit: (ev) => {
            ev.preventDefault();
            console.log("form submit event", form);
        },
    }}>
    <Fields equal>
        <Field wide="four" inline>

            <Input labeled="true" color="blue" size="small"  type="number"  min="0.00000000"  step="0.00000001"  bind:value={amount}  on:change={ ()=>{ i_amount = amount; amount = parseFloat(i_amount).toFixed(8)}}>
                <Label slot="right" basic size="mini"> Amount </Label>
                
            </Input>
            <label style="font-size: smaller; color: #aaa; padding-left: 1em">{currencyValue($BetSettingsLocal.currency, amount, "usd").toFixed(2)}<Icon name="dollar sign" /> </label>
        </Field>
   
        <Field wide="four" >
            {#if game == "limbo"}
                <Input labeled="right"  style={ { "margin-inline":"2px", "max-width": "120px"}} color="blue" size="small"   type="number" min="1.01" max="1000000" step="1" bind:value={i_multiplier}>
                    <Label basic> <Icon name="times" size="small" /> </Label>
                </Input>
            {/if}

            {#if  game == "dice"}
            
                <Input labeled="right" style={ { "margin-inline":"2px", "max-width": "120px"}} color="blue" size="small"   type="number"  min="1.0102"    max="9900"   step="1" bind:value={i_multiplier}>
                    <Label basic > <Icon name="times" size="small" /> </Label>
                </Input>
              
    
            {/if}
            {#if game == "limbo" ||  game == "dice"}
                <Input labeled="right" state="disabled" style={ { "margin-inline":"2px", "max-width": "120px"}} color="blue" size="small" type="number" min="0.0001"  max="100"    step="1"  bind:value={i_chance}>
                   
                    <Label basic > <Icon name="percent" size="small" /> </Label>
                </Input>
            {/if}
         </Field>


         <Field wide="three" inline>
            
            {#if game == "scarab" || game == "tomeoflife"}
                <Input labeled="right" color="blue" size="small" type="number" min="1" max="20" step="1"  bind:value={i_lines}>
               
                    <Label > Lines </Label>
                </Input>
            {/if}

            {#if game == "mines"}
                <Input labeled="right" color="blue" size="small"  type="number" min="1" max="24" step="1"   bind:value={i_minesCount}>                   
                    <Label > Mines </Label>
                </Input>
            {/if}
            
            {#if game == "dice"}
                    
                <Button size="medium"
                icon={ (i_condition == 'below') ? "less than" : "greater than"} 
                color={ (i_condition == 'below') ? "teal" : "orange" }
                on:click={ () => { i_condition == 'below' ? i_condition = 'above' : i_condition = 'below'}}
                >
                {i_condition}
                </Button>
            {/if}
            
            {#if game == "plinko" || game == "keno" || game == "wheel"}
                <div>
                    <select bind:value={i_risk}>
                        <option value="high">High</option>
                        <option value="medium">Medium</option>
                        <option value="low">Low</option>
                    </select>
                </div>
            {/if}

            {#if game == "dragontower"}
                <div>
                    <select bind:value={i_difficulty}>
                        <option value="master">Master</option>
                        <option value="expert">Expert</option>
                        <option value="hard">Hard</option>
                        <option value="medium">Medium</option>
                        <option value="easy">Easy</option>
                    </select>
                </div>
            {/if}

        </Field>


        <Field wide="four" inline>

            {#if game == "plinko"}
                    <Input labeled="right" color="blue" size="small" type="number"   min="8"  max="16"  step="1"   bind:value={i_rows}>
                        <Label > Rows </Label>
                    </Input>            
            {:else if game == "wheel"}
                    <Input labeled="right" color="blue" size="small"  bind:value={i_segments} type="number" min="10"  max="50" step="10" >
                       
                        <Label > segments </Label>
                    </Input>
            {/if}
            
        </Field>

        
    </Fields>
</Form>

<style>
</style>
